export default "__VITE_ASSET__DtNHbKYC__"